import React, { useEffect, useState, useRef, useContext } from "react";
import styles from "./styles/new_beneficiary.module.css";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";
import "./styles/phone.css";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import Info from "../User/Info/info";
import useWindowDimensions from "../Footer/footer";
import AssetType from "../User/Asset Type/AssetType";
import { RenderAvatarImageForBenefPortal } from "../../Utils/renderAvatarImage";

function TrusteePopupBenef({ toEdit, onClose, assets }) {
  const { height, width } = useWindowDimensions();

  const previewImage = toEdit.profile_avatar ? toEdit.profile_avatar : null;

  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const divElementRef = useRef(null);

  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddTrustee.NewTrustee
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddTrustee.NewTrustee);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [trustee, setTrustee] = useState({
    user_id: toEdit.user_id,
    name: toEdit.name,
    additional_information: toEdit.additional_information,
    email: toEdit.email,
    phone_number: toEdit.phone_number,
    awareness_status: toEdit.awareness_status,
    profile_avatar: toEdit.profile_avatar,
    assets,

    // assets: userData.UserData.assets
    //   .filter((asset) => asset.trustees.includes(toEdit.user_id))
    //   .map((e) => {
    //     return e.asset_id;
    //   }),
    // beneficiaries: userData.UserData.beneficiaries
    //   .filter((beneficiary) => beneficiary.trustees.includes(toEdit.user_id))
    //   .map((e) => {
    //     return e.user_id;
    //   }),
  });
  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const textareaRef = useRef(null);

  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);

  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={
          width <= 599
            ? {
                height: window.innerHeight - 10,
              }
            : {}
        }
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        <div className={styles.title}>
          {dublicatedcontent.view} {trustee.name}
        </div>
        <div
          className={`${styles.popup_scrollable} ${styles.popup_scrollable_edit}`}
          id="scrollContainer"
          ref={divElementRef}
        >
          <div
            className={`${styles.shadow_top} ${
              showTopShadow ? styles.active : ""
            }`}
          />

          <div className={styles.main_data}>
            <div
              className={styles.main_data_upper}
              style={{
                alignItems: "center",
              }}
            >
              <div className={styles.upper_left}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.newTrusteeText1}
                </div>
                <input
                  disabled={true}
                  value={trustee.name}
                  className={`${styles.beneficiary_input}`}
                  placeholder={content.newTrusteeText1}
                ></input>
              </div>
              {width > 590 && (
                <div
                  className={styles.upper_right}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transform: "translateY(33px)",
                  }}
                >
                  <div
                    className={`${styles.uploadPictureContainer} ${styles.black_logo_image}`}
                    style={{
                      width: "175px",
                      height: "175px",
                    }}
                  >
                    <div className={styles.upload_button_container}>
                      <div className={styles.upload_button}>
                        <RenderAvatarImageForBenefPortal
                          name={trustee.name}
                          avatar={previewImage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.delay_period}>
            <div className={`${styles.bold_title} ${styles.required_field}`}>
              {content.newTrusteeText2}
            </div>
            <Info message={content.newTrusteeText3} />
          </div>

          <div className={`${styles.main_data_upper}`}>
            <div className={styles.upper_left}>
              <div className={`${styles.input_title}`}>
                {content.newTrusteeText4}
              </div>
              <input
                disabled={true}
                value={trustee.email}
                className={styles.beneficiary_input_email}
                placeholder={content.newTrusteeText4}
              ></input>

              <div className={styles.choice}>
                {/* <InfoTitle
                  message={content.newTrusteeText5}
                  title={content.newTrusteeText6}
                  type={"small"}
                /> */}
              </div>
            </div>
            <div className={styles.upper_right}>
              <div className={styles.input_title}>
                {content.newTrusteeText8}
              </div>
              <div disabled={true} className={styles.phone_div}>
                <PhoneInput
                  value={trustee.phone_number}
                  localization={
                    websiteCurrentLang?.label === "fr"
                      ? fr_phone_countries
                      : undefined
                  }
                  country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                  placeholder={content.newTrusteeText9}
                />
              </div>

              {/* <InfoTitle
                movetoleft={true}
                message={content.newTrusteeText10}
                title={content.newTrusteeText11}
                type={"small"}
              /> */}
            </div>
            {width <= 590 && (
              <div
                className={styles.upper_right}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className={`${styles.uploadPictureContainer} ${styles.black_logo_image}`}
                  style={{
                    width: "200px",
                    height: "200px",
                  }}
                >
                  <div className={styles.upload_button_container}>
                    <div className={styles.upload_button}>
                      <RenderAvatarImageForBenefPortal
                        name={trustee.name}
                        avatar={previewImage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={styles.main_data_lower}>
            <div className={styles.delay_period}>
              <div className={styles.input_title}>
                {content.newTrusteeText12}
              </div>
            </div>
            <textarea
              disabled={true}
              maxLength={maxMessageLength}
              value={trustee.additional_information}
              ref={textareaRef}
              placeholder={content.newTrusteeText12}
              className={styles.large_message}
            ></textarea>

            <div
              className={`${styles.file_counter} ${
                trustee.additional_information?.length === maxMessageLength
                  ? styles.error_text
                  : ""
              }`}
            >
              {trustee.additional_information?.length === maxMessageLength ? (
                <>{content.newTrusteeText13}</>
              ) : (
                ""
              )}
              {trustee.additional_information?.length}/{maxMessageLength}{" "}
              {dublicatedcontent.dublicatedText93}
            </div>
          </div>
          <div>
            <div className={styles.delay_period}>
              <div className={styles.bold_title}>
                {content.newTrusteeText14}
              </div>
              <Info position={"top"} message={content.newTrusteeText15} />
              <div className={styles.assets_counter}>
                <span className={styles.assets_selected}>
                  {trustee?.assets?.length} Assets
                </span>
              </div>
            </div>
            <div disabled={true} className={styles.assets_div}>
              <div className={styles.assets_container}>
                {trustee.assets?.map((asset) => {
                  return (
                    <AssetType
                      removable={false}
                      key={asset.asset_id}
                      asset_type={asset.asset_type}
                      asset_name={asset.asset_name}
                      onDelete={() => {}}
                    />
                  );
                })}
              </div>
            </div>
          </div>

          <div
            className={`${styles.shadow_bottom} ${styles.shadow_bottom_edit} ${
              showBottomShadow ? styles.active : ""
            }`}
          />
        </div>

        <div className={styles.actions_toolbar}>
          <div onClick={() => onClose()} className={styles.cancel_button}>
            {dublicatedcontent.dublicatedText76}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrusteePopupBenef;
